<template>
  <div>
    <a-page-header style="width: 105%; margin-left: -20px" title="">
      <template slot="tags">
        <a-breadcrumb>
          <a-breadcrumb-item href="">
            <a-icon type="pie-chart" />
            <span>{{ $t("message.customGroup.title1") }}</span>
          </a-breadcrumb-item>
          <a-breadcrumb-item href="">
            <a-icon type="team" />
            <span>{{ $t("message.userGroupDetail.audienceRules") }}</span>
          </a-breadcrumb-item>
        </a-breadcrumb>
      </template>
    </a-page-header>
    <div class="page-title">{{ $t("message.userGroupDetail.audienceRules") }}</div>

    <a-spin :spinning="reload">
      <a-card style="margin-top: 30px">
        <a-row>
          <a-col :span="12">
            <span class="font-weight-600 black-color" style="padding-left: 26px">{{
              $t("message.userGroupDetail.filterExploration")
            }}</span>
          </a-col>
          <a-col :span="12">
            <div style="float: right; margin-right: 50px">
              <a-button  :size="$globalSize"  type="primary" @click="backToListPage">{{
                $t("message.userGroupDetail.goBack")
              }}</a-button>
            </div>
          </a-col>
        </a-row>
        <a-form-model
          ref="unionForm"
          :model="unionForm"
          v-bind="formItemLayoutWithOutLabel"
          id="unionForm"
        >
          <div
            v-for="(domain, index) in unionForm.domains"
            :style="{ marginTop: index != 0 ? '0px' : '0px' }"
            :key="index"
          >
            <a-tabs
              :activeKey="
                typeof domain[0].apposition != 'undefined' ? domain[0].apposition : '且'
              "
              v-if="index != 0 && !readonly"
              @change="tabUnionChange"
              disabled
            >
              <a-tab-pane key="且" tab="AND"></a-tab-pane>
              <a-tab-pane key="或" tab="OR"></a-tab-pane>
            </a-tabs>
            <a-card :style="{ marginTop: index != 0 ? '10px' : '10px' }">
              <div class="close-total-filter">
                <!--                                <a-icon type="close" />-->
              </div>
              <a-row :gutter="16" v-for="(child, childIndex) in domain" :key="child.key">
                <a-col :md="{ span: 1 }" :xxl="{ span: 1 }" v-if="childIndex != 0">
                  <a-form-model-item v-bind="{ wrapperCol: { span: 24 } }">
                    <span style="font-size: 14px; font-weight: 500; float: right">{{
                      child.apposition == "且" ? "AND:" : "OR:"
                    }}</span>
                  </a-form-model-item>
                </a-col>
                <a-col :md="{ span: 1 }" :xxl="{ span: 1 }" v-else></a-col>
                <a-col :md="{ span: 7 }" :xxl="{ span: 6 }">
                  <a-form-model-item
                    v-bind="{ wrapperCol: { span: 24 } }"
                    :prop="'domains.' + index + '.' + childIndex + '.tag_id'"
                    :rules="{
                      required: true,
                      message: '请选择标签',
                      trigger: ['blur', 'change'],
                    }"
                  >
                    <a-tree-select :size="$globalSize"
                      disabled
                      v-model="child.tag_id"
                      show-search
                      style="width: 100%"
                      :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                      placeholder="请选择标签"
                      allow-clear
                      tree-default-expand-all
                      treeNodeFilterProp="title"
                      @change="handleUnionChildTagChange(index, childIndex)"
                    >
                      <a-tree-select-node
                        v-for="tag_level_one in tagAll.options"
                        :selectable="false"
                        :key="tag_level_one.value"
                        :value="tag_level_one.value"
                        :title="tag_level_one.label"
                      >
                        <a-tree-select-node
                          v-for="tag_level_two in tag_level_one.children"
                          :selectable="false"
                          :key="tag_level_two.value"
                          :value="tag_level_two.value"
                          :title="tag_level_two.label"
                        >
                          <a-tree-select-node
                            v-for="tag in tag_level_two.children"
                            :selectable="tag.is_disabled == 0 ? false : true"
                            :key="tag.value"
                            :value="tag.value"
                            :title="tag.label"
                          >
                          </a-tree-select-node>
                        </a-tree-select-node>
                      </a-tree-select-node>
                    </a-tree-select>
                  </a-form-model-item>
                </a-col>
                <a-col
                  :md="{ span: 4 }"
                  :xxl="{ span: 3 }"
                  v-show="typeof child.tag_id != 'undefined' && child.tag_id.length > 0"
                >
                  <a-form-model-item
                    v-bind="{ wrapperCol: { span: 24 } }"
                    :prop="'domains.' + index + '.' + childIndex + '.calc'"
                    :rules="{
                      required: true,
                      message: '请选择计算规则',
                      trigger: ['blur', 'change'],
                    }"
                  >
                    <a-select :size="$globalSize"
                      disabled
                      :default-value="child.calc"
                      v-model="child.calc"
                      style="width: 100%"
                      placeholder="请选择计算规则"
                    >
                        <a-select-option v-for="calc in child.calcOptions" :key="calc.value">
                          {{ calc.label }}
                        </a-select-option>

                    </a-select>
                  </a-form-model-item>
                </a-col>
                <a-col
                  :md="{ span: 9 }"
                  :xxl="{ span: 10 }"
                  v-show="typeof child.tag_id != 'undefined' && child.tag_id.length > 0"
                >
                  <a-form-model-item
                    v-if="
                      typeof child.valueOptions[0] != 'undefined' &&
                      child.valueOptions[0].tag_val == 'time'
                    "
                    v-bind="{ wrapperCol: { span: 24 } }"
                    :prop="'domains.' + index + '.' + childIndex + '.value'"
                    :rules="{
                      required: true,
                      message: '请选择日期',
                      trigger: ['blur', 'change'],
                    }"
                  >
                    <a-date-picker :size="$globalSize"
                      format="YYYY-MM-DD"
                      style="width: 100%"
                      v-if="child.calc == '等于'"
                      v-model="child.value[0]"
                      disabled
                    />
                    <a-range-picker  :size="$globalSize"
                      v-else
                      format="YYYY-MM-DD"
                      v-model="child.value"
                      :ranges="{
                        最近一周: [moment().subtract(7, 'days'), moment()],
                        最近两周: [moment().subtract(14, 'days'), moment()],
                        最近一月: [moment().subtract(1, 'months'), moment()],
                        最近三月: [moment().subtract(3, 'months'), moment()],
                        最近半年: [moment().subtract(6, 'months'), moment()],
                        最近一年: [moment().subtract(1, 'years'), moment()],
                      }"
                      style="width: 100%"
                      disabled
                    />
                  </a-form-model-item>
                  <a-form-model-item
                    v-else-if="child.valueOptionsType == 'time'"
                    v-bind="{ wrapperCol: { span: 24 } }"
                    :prop="'domains.' + index + '.' + childIndex + '.value'"
                    :rules="{
                      required: true,
                      message: '请选择日期',
                      trigger: ['blur', 'change'],
                    }"
                  >
                    <template v-if="child.calc == '在区间' && child.dynamic_time">
                      <a-tag>动态时间</a-tag>
                      <a-input :size="$globalSize" v-model="child.value[0]" style="width: 90px" disabled />
                      <a-input :size="$globalSize"
                        v-model="child.value[1]"
                        style="width: 90px; margin-left: 10px"
                        disabled
                      />
                    </template>
                    <a-range-picker  :size="$globalSize"
                      v-else
                      format="YYYY-MM-DD"
                      v-model="child.value"
                      :ranges="{
                        最近一周: [moment().subtract(7, 'days'), moment()],
                        最近两周: [moment().subtract(14, 'days'), moment()],
                        最近一月: [moment().subtract(1, 'months'), moment()],
                        最近三月: [moment().subtract(3, 'months'), moment()],
                        最近半年: [moment().subtract(6, 'months'), moment()],
                        最近一年: [moment().subtract(1, 'years'), moment()],
                      }"
                      style="width: 100%"
                      disabled
                    />
                  </a-form-model-item>
                  <a-form-model-item
                    v-else
                    v-bind="{ wrapperCol: { span: 24 } }"
                    :prop="'domains.' + index + '.' + childIndex + '.value'"
                    :rules="{
                      required: true,
                      message:
                        child.valueOptions.length < 1 ? '请填写完整' : '请选择选项',
                      trigger: ['blur', 'change'],
                    }"
                  >
                    <a-select :size="$globalSize"
                      disabled
                      :mode="
                        child.valueOptions.length < 1
                          ? 'tags'
                          : child.calc.includes('包含')
                          ? 'default'
                          : 'multiple'
                      "
                      :default-value="child.value"
                      v-model="child.value"
                      :maxTagCount="maxNumInner"
                      optionFilterProp="title"
                      style="width: 100%"
                      :placeholder="child.valueOptions.length < 1 ? '请输入' : '请选择'"
                    >
                      <a-select-option
                        v-for="item in child.valueOptions"
                        :key="item.tag_id"
                        :title="item.tag_val"
                      >
                        {{ item.tag_val }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
                <a-col :md="{ span: 1 }" :xxl="{ span: 2 }">
                  <a-form-model-item v-bind="{ wrapperCol: { span: 24 } }">
                    <!--                                        <a-icon-->
                    <!--                                            class="dynamic-delete-button"-->
                    <!--                                            type="minus-circle-o"-->
                    <!--                                        />-->
                  </a-form-model-item>
                </a-col>
              </a-row>
              <!--                            <div class="inner-add-filter">-->
              <!--                                <a-button  :size="$globalSize"  v-show="typeof domain[1] == 'undefined' || (typeof domain[1] != 'undefined' && domain[1].apposition=='且')" @click="addUnionDomainChild(index, 'and')">-->
              <!--                                    增加AND条件-->
              <!--                                </a-button>-->
              <!--                                <a-button  :size="$globalSize"  v-show="typeof domain[1] == 'undefined' || (typeof domain[1] != 'undefined' && domain[1].apposition=='或')" @click="addUnionDomainChild(index, 'or')">-->
              <!--                                    增加OR条件-->
              <!--                                </a-button>-->
              <!--                            </div>-->
            </a-card>
          </div>
        </a-form-model>
        <a-card class="filter-card-different" v-if="differentForm.domains.length > 0">
          <div class="different-title">
            <a-icon type="minus-circle" /><span style="margin-left: 20px"
              >排除以下人群</span
            >
          </div>
          <a-form-model
            ref="differentForm"
            :model="differentForm"
            v-bind="formItemLayoutWithOutLabel"
            id="differentForm"
          >
            <div
              v-for="(domain, index) in differentForm.domains"
              :style="{ marginTop: index != 0 ? '20px' : '30px' }"
              :key="index"
            >
              <a-tabs
                :activeKey="domain[0].apposition"
                v-if="index != 0"
                @change="tabDifferentChange"
              >
                <a-tab-pane key="且" tab="AND" disabled></a-tab-pane>
                <a-tab-pane key="或" tab="OR" disabled></a-tab-pane>
              </a-tabs>
              <a-card :style="{ marginTop: index != 0 ? '-17px' : '0px' }">
                <div class="close-total-filter">
                  <!--                                    <a-icon type="close" />-->
                </div>
                <a-row
                  :gutter="16"
                  v-for="(child, childIndex) in domain"
                  :key="child.key"
                >
                  <a-col :md="{ span: 2 }" :xxl="{ span: 1 }" v-if="childIndex != 0">
                    <a-form-model-item v-bind="{ wrapperCol: { span: 24 } }">
                      <span style="font-size: 14px; font-weight: 500; float: right">{{
                        child.apposition == "且" ? "AND:" : "OR:"
                      }}</span>
                    </a-form-model-item>
                  </a-col>
                  <a-col :md="{ span: 7 }" :xxl="{ span: 6 }">
                    <a-form-model-item
                      v-bind="{ wrapperCol: { span: 24 } }"
                      :prop="'domains.' + index + '.' + childIndex + '.tag_id'"
                      :rules="{
                        required: true,
                        message: '请选择标签',
                        trigger: ['blur', 'change'],
                      }"
                    >
                      <a-tree-select :size="$globalSize"
                        disabled
                        v-model="child.tag_id"
                        show-search
                        style="width: 100%"
                        :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                        placeholder="请选择标签"
                        allow-clear
                        tree-default-expand-all
                        treeNodeFilterProp="title"
                        @change="handleDifferentChildTagChange(index, childIndex)"
                      >
                        <a-tree-select-node
                          v-for="tag_level_one in tagAll.options"
                          :selectable="false"
                          :key="tag_level_one.value"
                          :value="tag_level_one.value"
                          :title="tag_level_one.label"
                        >
                          <a-tree-select-node
                            v-for="tag_level_two in tag_level_one.children"
                            :selectable="false"
                            :key="tag_level_two.value"
                            :value="tag_level_two.value"
                            :title="tag_level_two.label"
                          >
                            <a-tree-select-node
                              v-for="tag in tag_level_two.children"
                              :selectable="tag.is_disabled == 0 ? false : true"
                              :key="tag.value"
                              :value="tag.value"
                              :title="tag.label"
                            >
                            </a-tree-select-node>
                          </a-tree-select-node>
                        </a-tree-select-node>
                      </a-tree-select>
                    </a-form-model-item>
                  </a-col>
                  <a-col
                    :md="{ span: 4 }"
                    :xxl="{ span: 3 }"
                    v-show="typeof child.tag_id != 'undefined' && child.tag_id.length > 0"
                  >
                    <a-form-model-item
                      v-bind="{ wrapperCol: { span: 24 } }"
                      :prop="'domains.' + index + '.' + childIndex + '.calc'"
                      :rules="{
                        required: true,
                        message: '请选择计算规则',
                        trigger: ['blur', 'change'],
                      }"
                    >
                      <a-select :size="$globalSize"
                        disabled
                        :default-value="child.calc"
                        v-model="child.calc"
                        style="width: 100%"
                        placeholder="请选择计算规则"
                      >
                          <a-select-option v-for="calc in child.calcOptions" :key="calc.value">
                            {{ calc.label }}
                          </a-select-option>
                      </a-select>
                    </a-form-model-item>
                  </a-col>
                  <a-col
                    :md="{ span: 9 }"
                    :xxl="{ span: 10 }"
                    v-show="typeof child.tag_id != 'undefined' && child.tag_id.length > 0"
                  >
                    <a-form-model-item
                      v-if="
                        typeof child.valueOptions[0] != 'undefined' &&
                        child.valueOptions[0].label == 'time'
                      "
                      v-bind="{ wrapperCol: { span: 24 } }"
                      :prop="'domains.' + index + '.' + childIndex + '.value'"
                      :rules="{
                        required: true,
                        message: '请选择日期',
                        trigger: ['blur', 'change'],
                      }"
                    >
                      <a-date-picker :size="$globalSize"
                        format="YYYY-MM-DD"
                        style="width: 100%"
                        v-if="child.calc == '等于'"
                        v-model="child.value[0]"
                        disabled
                      />
                      <a-range-picker  :size="$globalSize"
                        v-else
                        format="YYYY-MM-DD"
                        v-model="child.value"
                        :ranges="{
                          最近一周: [moment().subtract(7, 'days'), moment()],
                          最近两周: [moment().subtract(14, 'days'), moment()],
                          最近一月: [moment().subtract(1, 'months'), moment()],
                          最近三月: [moment().subtract(3, 'months'), moment()],
                          最近半年: [moment().subtract(6, 'months'), moment()],
                          最近一年: [moment().subtract(1, 'years'), moment()],
                        }"
                        style="width: 100%"
                        disabled
                      />
                    </a-form-model-item>
                    <a-form-model-item
                      v-else
                      v-bind="{ wrapperCol: { span: 24 } }"
                      :prop="'domains.' + index + '.' + childIndex + '.value'"
                      :rules="{
                        required: true,
                        message:
                          child.valueOptions.length < 1 ? '请填写完整' : '请选择选项',
                        trigger: ['blur', 'change'],
                      }"
                    >
                      <a-select :size="$globalSize"
                        disabled
                        :mode="
                          child.valueOptions.length < 1
                            ? 'tags'
                            : child.calc.includes('包含')
                            ? 'default'
                            : 'multiple'
                        "
                        :default-value="child.value"
                        v-model="child.value"
                        :maxTagCount="maxNumInner"
                        optionFilterProp="title"
                        style="width: 100%"
                        :placeholder="child.valueOptions.length < 1 ? '请输入' : '请选择'"
                      >
                        <a-select-option
                          v-for="item in child.valueOptions"
                          :key="item.value"
                          :title="item.label"
                        >
                          {{ item.label }}
                        </a-select-option>
                      </a-select>
                    </a-form-model-item>
                  </a-col>
                  <a-col :md="{ span: 1 }" :xxl="{ span: 2 }">
                    <a-form-model-item v-bind="{ wrapperCol: { span: 24 } }">
                      <!--                                            <a-icon-->
                      <!--                                                class="dynamic-delete-button"-->
                      <!--                                                type="minus-circle-o"-->
                      <!--                                            />-->
                    </a-form-model-item>
                  </a-col>
                </a-row>
                <!--                                <div class="inner-add-filter">-->
                <!--                                    <a-button  :size="$globalSize"  v-show="typeof domain[1] == 'undefined' || (typeof domain[1] != 'undefined' && domain[1].apposition=='且')" @click="addDifferentDomainChild(index, 'and')">-->
                <!--                                        增加AND条件-->
                <!--                                    </a-button>-->
                <!--                                    <a-button  :size="$globalSize"  v-show="typeof domain[1] == 'undefined' || (typeof domain[1] != 'undefined' && domain[1].apposition=='或')" @click="addDifferentDomainChild(index, 'or')">-->
                <!--                                        增加OR条件-->
                <!--                                    </a-button>-->
                <!--                                </div>-->
              </a-card>
            </div>
          </a-form-model>
        </a-card>
        <div class="card-footer">
          <div class="check-box-div">
            <!-- <a-checkbox v-model="showShrink" @change="shrinkPopulation" disabled>
                            随机抽取人群
                        </a-checkbox> -->
            <span v-if="showShrinkNum">{{ showThousandNum(shrinkNum) }} 人</span>
          </div>
          <div class="button-div">
            <!--                        <a-button  :size="$globalSize"  @click="addDifferentDomain">-->
            <!--                            增加排除人群-->
            <!--                        </a-button>-->
            <!--                        <a-button  :size="$globalSize"  type="primary" @click="addUnionDomain">-->
            <!--                            <a-icon type="plus" />-->
            <!--                            增加筛选模块-->
            <!--                        </a-button>-->
            <!--                        <a-button  :size="$globalSize"  type="primary" @click="openSaveModal">-->
            <!--                            预览并保存-->
            <!--                        </a-button>-->
            {{
              $t("message.userGroupDetail.totalNumberOfPeople") +
              "：" +
              showThousandNum(popNum) +
              " " +
              $t("message.userGroupDetail.people")
            }}
          </div>
        </div>
      </a-card>
    </a-spin>
  </div>
</template>

<script>
import moment from "moment";
import utils from "@/utils";
import addUserGroupService from "../../interface/pages/UserGroup/addUserGroup";
let loadPopNum;

export default {
  name: "UserGroupDetail",
  data() {
    return {
      // loading
      reload: false,
      readonly:false,
      // date
      dateFormat: "YYYY/MM/DD",
      showUnionTimeRange1: false,
      showUnionTimeRange2: false,
      showUnionTimeRange3: false,
      showDifferentTimeRange1: false,
      showDifferentTimeRange2: false,
      showDifferentTimeRange3: false,
      // filters
      unionForm: {
        timeRange1: [],
        timeRange2: [],
        timeRange3: [],
        domains: [
          [
            {
              apposition: "且",
              tag_id: [],
              calc: [],
              calcOptions: [],
              value: [],
              valueOptions: [],
              key: Date.now(),
            },
          ],
        ],
      },
      differentForm: {
        timeRange1: [],
        timeRange2: [],
        timeRange3: [],
        divHeight: 0,
        domains: [],
      },
      tagAll: {
        children: [],
        options: [],
      },
      // random
      showShrink: false,
      shrinkUser: false,
      shrinkForm: {
        shrink_switch: false,
        shrink_slide: 10,
        shrink_input: 10,
        shrink_user_num: 0,
      },
      shrinkNum: 0,
      showShrinkNum: false,
      // modal
      popNum: 0,
      saveModal: false,
      saveForm: {
        group_name: "",
        group_type: "",
      },
      groupTypeOptions: [
        {
          label: "所有分群",
          value: "所有分群",
        },
        {
          label: "系统预置的",
          value: "系统预置的",
        },
        {
          label: "我创建的",
          value: "我创建的",
        },
        {
          label: "共享给我的",
          value: "共享给我的",
        },
        {
          label: "促销人群",
          value: "促销人群",
        },
        {
          label: "自定义分组",
          value: "自定义分组",
        },
      ],
      saveFormRules: {
        group_name: [{ required: true, message: "请填写人群名称", trigger: "blur" }],
        group_type: [{ required: true, message: "请选择计算类型", trigger: "blur" }],
      },
      // 标记多选框最多显示个数
      maxNumOuter: window.screen.height < 1080 ? 1 : window.screen.height <= 2160 ? 3 : 5,
      maxNumInner: window.screen.height < 1080 ? 1 : window.screen.height <= 2160 ? 2 : 4,
      // authority
      admin: false,
      // authorityButton: "",
      // formLabel
      formItemLayout: {
        labelCol: {
          span: 9,
        },
        wrapperCol: {
          span: 15,
        },
      },
      formItemLayoutWithOutLabel: {
        wrapperCol: {
          md: {
            offset: 3,
            span: 2,
          },
          xxl: {
            offset: 2,
            span: 1,
          },
        },
      },
      formItemLayoutWithOutLabelChild: {
        wrapperCol: {
          md: {
            offset: 2,
            span: 2,
          },
          xxl: {
            offset: 1,
            span: 1,
          },
        },
      },
      tabList: [
        {
          key: "且",
          tab: "AND",
        },
        {
          key: "或",
          tab: "OR",
        },
      ],
      userTags: "",
    };
  },
  mounted() {
    this.readonly = this.$route.params.readonly;
    let tag_cnd = this.$route.params.tag_cnd;
    if (typeof tag_cnd != "undefined" && tag_cnd.length > 3) {
      let copy_data = JSON.parse(tag_cnd);
      this.unionForm = {
        timeRange1: [],
        timeRange2: [],
        timeRange3: [],
        domains: [],
      };
      this.differentForm = {
        timeRange1: [],
        timeRange2: [],
        timeRange3: [],
        domains: [],
      };
      this.$nextTick(() => {
        this.unionForm = this.getDomains(copy_data["unionForm"]);
        this.differentForm = this.getDomains(copy_data["differentForm"]);
        this.popNum = this.$route.params.user_count;
        if (typeof copy_data["random_count"] != "undefined") {
          this.showShrink = true;
          this.showShrinkNum = true;
          this.shrinkNum = copy_data["random_count"];
        }
      });
    }
    setTimeout(() => {
      this.reload = false;
    }, 800);
  },
  methods: {
    moment,
    backToListPage() {
      this.$router.push({
        name: "UserGroupListV2",
      });
    },
    // 获取当前用户角色
    getRole() {
      addUserGroupService
        .getUserRole(this, { params: {} })
        .then(
          function (response) {
            let res = response.data;
            if (res.code == "200") {
              this.admin = Boolean(res.data);
            }
          }.bind(this)
        )
        .catch((response) => {
          console.log(response);
        });
    },
    // 获取当前用户的按钮权限
    // getUserAuthorityButton() {
    //     let body = {};
    //     userGroupListService.authorityButton(this, {params: body}).then(function (response) {
    //         let res = response.data;
    //         if (res.code == '200') {
    //             this.authorityButton = res.data;
    //         } else {
    //             this.$message.success(res.message);
    //         }
    //     }.bind(this)).catch(response => {
    //         console.log(response);
    //     });
    // },
    // 获取下拉框的值
    getFilters() {
      let body = {};
      addUserGroupService
        .tagFilters(this, { params: body })
        .then(
          function (response) {
            let res = response.data;
            if (res.code == "200") {
              this.userTags = res.data.tags;
              this.tagAll.options = res.data.options;
              // this.tagAll = res.data;
              // let tag_cnd = this.$route.params.tag_cnd;
            }
          }.bind(this)
        )
        .catch((response) => {
          console.log(response);
        });
    },
    haveTag(value) {
      let index = this.userTags.indexOf(value);
      if (index < 0) {
        return false;
      }
      let next_index = this.userTags.indexOf(",", index);
      let sub = "";
      if (next_index >= 0) {
        sub = this.userTags.substring(index, next_index);
      } else {
        sub = this.userTags.substring(index, this.userTags.length);
      }
      if (value == sub) {
        return true;
      }
      return false;
    },
    // 增加排除人群
    addDifferentDomain() {
      this.showShrink = false;
      this.shrinkForm = {
        shrink_switch: false,
        shrink_slide: 10,
        shrink_input: 10,
        shrink_user_num: 0,
      };
      this.showShrinkNum = false;
      this.differentForm.domains.push([
        {
          apposition: "且",
          tag_id: [],
          calc: [],
          calcOptions: [],
          value: [],
          valueOptions: [],
          timeRange: [],
          key: Date.now(),
        },
      ]);
    },
    removeDifferent() {
      this.showShrink = false;
      this.shrinkForm = {
        shrink_switch: false,
        shrink_slide: 10,
        shrink_input: 10,
        shrink_user_num: 0,
      };
      this.showShrinkNum = false;
      this.differentForm.domains = [];
    },
    removeDifferentDomain(index) {
      if (index !== -1) {
        this.differentForm.domains.splice(index, 1);
        this.showShrink = false;
        this.shrinkForm = {
          shrink_switch: false,
          shrink_slide: 10,
          shrink_input: 10,
          shrink_user_num: 0,
        };
        this.showShrinkNum = false;
      }
    },
    // 增加筛选模块
    addUnionDomain() {
      this.showShrink = false;
      this.shrinkForm = {
        shrink_switch: false,
        shrink_slide: 10,
        shrink_input: 10,
        shrink_user_num: 0,
      };
      this.showShrinkNum = false;
      this.unionForm.domains.push([
        {
          apposition: this.unionForm.domains[0][0].apposition,
          tag_id: [],
          calc: [],
          calcOptions: [],
          value: [],
          valueOptions: [],
          timeRange: [],
          key: Date.now(),
        },
      ]);
    },
    removeUnionDomain(index) {
      if (index !== -1) {
        this.unionForm.domains.splice(index, 1);
        this.showShrink = false;
        this.shrinkForm = {
          shrink_switch: false,
          shrink_slide: 10,
          shrink_input: 10,
          shrink_user_num: 0,
        };
        this.showShrinkNum = false;
      }
    },
    // union
    addUnionDomainChild(index, apposition) {
      let len = this.unionForm.domains[index].length;
      if (len > 0) {
        let tag_id = this.unionForm.domains[index][len - 1].tag_id;
        let calc = this.unionForm.domains[index][len - 1].calc;
        let value = this.unionForm.domains[index][len - 1].value;
        if (
          typeof tag_id == "undefined" ||
          tag_id.length < 1 ||
          typeof calc == "undefined" ||
          calc.length < 1 ||
          typeof value == "undefined" ||
          value.length < 1
        ) {
          this.$message.info(this.$t('message.addUserGroup.CompletetheConditions'));
          return;
        }
      }
      this.showShrink = false;
      this.shrinkForm = {
        shrink_switch: false,
        shrink_slide: 10,
        shrink_input: 10,
        shrink_user_num: 0,
      };
      this.showShrinkNum = false;
      this.unionForm.domains[index].push({
        apposition: apposition == "and" ? "且" : "或",
        tag_id: [],
        calc: [],
        calcOptions: [],
        value: [],
        valueOptions: [],
        key: Date.now(),
      });
    },
    removeUnionDomainChild(index, childIndex) {
      if (index !== -1) {
        if (this.unionForm.domains[index].length == 1) {
          this.unionForm.domains.splice(index, 1);
        } else {
          this.unionForm.domains[index].splice(childIndex, 1);
        }
        this.showShrink = false;
        this.shrinkForm = {
          shrink_switch: false,
          shrink_slide: 10,
          shrink_input: 10,
          shrink_user_num: 0,
        };
        this.showShrinkNum = false;
      }
    },
    handleUnionChildTagChange(index, childIndex) {
      let tag_id = this.unionForm.domains[index][childIndex].tag_id;
      if (tag_id == null || tag_id.length < 1) {
        return;
      }
      let valueOptions = this.tagAll.children[tag_id.substring(2, tag_id.length)];
      if (typeof valueOptions == "undefined" || valueOptions.length == 0) {
        this.unionForm.domains[index][childIndex].valueOptions = [];
        this.unionForm.domains[index][childIndex].value = [];
      } else {
        this.unionForm.domains[index][childIndex].valueOptions = valueOptions;
        this.unionForm.domains[index][childIndex].value = [];
      }
      this.handleUnionChildCalcChange(index, childIndex);
    },
    handleUnionChildCalcChange(index, childIndex) {
      this.unionForm.domains[index][childIndex].calcOptions = [];
      let valueOptions = this.unionForm.domains[index][childIndex].valueOptions;
      if (valueOptions.length < 1) {
        this.unionForm.domains[index][childIndex].calcOptions = [
          {
            value: "等于",
            label: this.$t('message.addUserGroup.EqualsTo')
          },
          {
            value: "大于",
            label: this.$t('message.addUserGroup.GreaterThan')
          },
          {
            value: "大于等于",
            label:this.$t('message.addUserGroup.GreaterThanOrEqualTo')
          },
          {
            value: "小于",
            label:this.$t('message.addUserGroup.LessThan')
          },
          {
            value: "小于等于",
            label:this.$t('message.addUserGroup.LessThanOrEqualTo')
          }
        ];
      } else if (valueOptions[0].label == "time") {
        this.unionForm.domains[index][childIndex].calcOptions = [
          {
            value: "等于",
            label:this.$t('message.addUserGroup.EqualsTo'),
          },
          {
            value: "在区间",
            label:()=>this.$t('message.addUserGroup.InInterval'),
          },
        ];
      } else {
        this.unionForm.domains[index][childIndex].calcOptions = [
          {
            value: "等于",
            label:this.$t('message.addUserGroup.EqualsTo'),
          },
          {
            value: "不等于",
            label:this.$t('message.addUserGroup.NotEqualTo'),
          },
          {
            value: "包含",
            label:this.$t('message.addUserGroup.Include'),
          },
          {
            value: "不包含",
            label:this.$t('message.addUserGroup.Excluding'),
          },
        ];
      }
      this.unionForm.domains[index][childIndex].calc = [];
    },
    // diff
    addDifferentDomainChild(index, apposition) {
      let len = this.differentForm.domains[index].length;
      if (len > 0) {
        let tag_id = this.differentForm.domains[index][len - 1].tag_id;
        let calc = this.differentForm.domains[index][len - 1].calc;
        let value = this.differentForm.domains[index][len - 1].value;
        if (
          typeof tag_id == "undefined" ||
          tag_id.length < 1 ||
          typeof calc == "undefined" ||
          calc.length < 1 ||
          typeof value == "undefined" ||
          value.length < 1
        ) {
          this.$message.info(this.$t('message.addUserGroup.CompletetheConditions'));
          return;
        }
      }
      this.showShrink = false;
      this.shrinkForm = {
        shrink_switch: false,
        shrink_slide: 10,
        shrink_input: 10,
        shrink_user_num: 0,
      };
      this.showShrinkNum = false;
      this.differentForm.domains[index].push({
        apposition: apposition == "and" ? "且" : "或",
        tag_id: [],
        calc: [],
        calcOptions: [],
        value: [],
        valueOptions: [],
        key: Date.now(),
      });
    },
    removeDifferentDomainChild(index, childIndex) {
      if (index !== -1) {
        if (this.differentForm.domains[index].length == 1) {
          this.differentForm.domains.splice(index, 1);
        } else {
          this.differentForm.domains[index].splice(childIndex, 1);
        }
        this.showShrink = false;
        this.shrinkForm = {
          shrink_switch: false,
          shrink_slide: 10,
          shrink_input: 10,
          shrink_user_num: 0,
        };
        this.showShrinkNum = false;
      }
    },
    handleDifferentChildTagChange(index, childIndex) {
      let tag_id = this.differentForm.domains[index][childIndex].tag_id;
      if (tag_id == null || tag_id.length < 1) {
        return;
      }
      let valueOptions = this.tagAll.children[tag_id.substring(2, tag_id.length)];
      if (typeof valueOptions == "undefined" || valueOptions.length == 0) {
        this.differentForm.domains[index][childIndex].valueOptions = [];
        this.differentForm.domains[index][childIndex].value = [];
      } else {
        this.differentForm.domains[index][childIndex].valueOptions = valueOptions;
        this.differentForm.domains[index][childIndex].value = [];
      }
      this.handleDifferentChildCalcChange(index, childIndex);
    },
    handleDifferentChildCalcChange(index, childIndex) {
      this.differentForm.domains[index][childIndex].calcOptions = [];
      let valueOptions = this.differentForm.domains[index][childIndex].valueOptions;
      if (valueOptions.length < 1) {
        this.differentForm.domains[index][childIndex].calcOptions = [
          {
            value: "等于",
            label:this.$t('message.addUserGroup.EqualsTo')
          },
          {
            value: "大于",
            label:this.$t('message.addUserGroup.GreaterThan')
          },
          {
            value: "大于等于",
            label:this.$t('message.addUserGroup.GreaterThanOrEqualTo')
          },
          {
            value: "小于",
            label:this.$t('message.addUserGroup.LessThan')
          },
          {
            value: "小于等于",
            label:this.$t('message.addUserGroup.LessThanOrEqualTo')
          }
        ];
      } else if (valueOptions[0].label == "time") {
        this.differentForm.domains[index][childIndex].calcOptions = [
          {
            value: "等于",
            label:this.$t('message.addUserGroup.EqualsTo'),
          },
          {
            value: "在区间",
            label:this.$t('message.addUserGroup.InInterval'),
          },
        ];
      } else {
        this.differentForm.domains[index][childIndex].calcOptions = [
          {
            value: "等于",
            label:this.$t('message.addUserGroup.EqualsTo'),
          },
          {
            value: "不等于",
            label:this.$t('message.addUserGroup.NotEqualTo'),
          },
          {
            value: "包含",
            label:this.$t('message.addUserGroup.Include'),
          },
          {
            value: "不包含",
            label:this.$t('message.addUserGroup.Excluding'),
          },
        ];
      }
      this.differentForm.domains[index][childIndex].calc = [];
    },
    // 多选框选中/取消选中触发
    shrinkPopulation(e) {
      this.showShrink = e.target.checked;
      if (this.showShrink) {
        this.loadPopulation();
        this.shrinkForm.shrink_user_num = loadPopNum;
        this.shrinkUser = this.showShrink;
      }
    },
    shrinkSlideFormatter(value) {
      if (this.shrinkForm.shrink_switch) {
        return `随机抽取${value}%`;
      } else {
        return `随机抽取${value}倍`;
      }
    },
    shrinkSwitchChange(value) {
      this.shrinkForm.shrink_slide = 10;
      let num_tmp = String(this.shrinkForm.shrink_user_num / 10);
      if (num_tmp.indexOf(".") >= 0) {
        num_tmp = num_tmp.substring(0, num_tmp.indexOf("."));
      }
      this.shrinkForm.shrink_input = Number(num_tmp);
    },
    shrinkSlideChange(value) {
      let num_tmp = String(
        (this.shrinkForm.shrink_slide * this.shrinkForm.shrink_user_num) / 100
      );
      if (num_tmp.indexOf(".") >= 0) {
        num_tmp = num_tmp.substring(0, num_tmp.indexOf("."));
      }
      this.shrinkForm.shrink_input = Number(num_tmp);
      this.shrinkForm.shrink_input =
        this.shrinkForm.shrink_input > 100000 ? 100000 : this.shrinkForm.shrink_input;
    },
    shrinkUserOk() {
      this.shrinkUser = false;
      this.showShrinkNum = true;
      this.shrinkNum =
        this.shrinkForm.shrink_user_num < this.shrinkForm.shrink_input
          ? this.shrinkForm.shrink_user_num
          : this.shrinkForm.shrink_input;
      shrink = this.shrinkNum;
    },
    shrinkUserCancel() {
      this.shrinkUser = false;
      this.showShrink = false;
    },
    // card-tab切换
    tabUnionChange(val) {
      let len = this.unionForm.domains.length;
      for (let i = 0; i < len; i++) {
        this.unionForm.domains[i][0].apposition = val;
      }
    },
    tabDifferentChange(val) {
      let len = this.differentForm.domains.length;
      for (let i = 0; i < len; i++) {
        this.differentForm.domains[i][0].apposition = val;
      }
    },
    // 生成es表达式
    getCalc() {
      this.calc_time_arr = [];
      let calc = {
        bool: {
          filter: {
            bool: {},
          },
        },
      };
      let unionTimeRange1 = this.unionForm.timeRange1;
      let unionTimeRange2 = this.unionForm.timeRange2;
      let unionTimeRange3 = this.unionForm.timeRange3;
      let differentTimeRange1 = this.differentForm.timeRange1;
      let differentTimeRange2 = this.differentForm.timeRange2;
      let differentTimeRange3 = this.differentForm.timeRange3;

      let union_parent_apposition = this.unionForm.domains[0][0].apposition;
      if (union_parent_apposition == "且") {
        calc.bool.filter.bool.must = [];
      } else {
        calc.bool.filter.bool.should = [];
      }
      for (let i = 0; i < this.unionForm.domains.length; i++) {
        for (let j = 0; j < this.unionForm.domains[i].length; j++) {
          let apposition =
            this.unionForm.domains[i].length > 1
              ? this.unionForm.domains[i][1].apposition
              : this.unionForm.domains[i][0].apposition;
          let operate = this.unionForm.domains[i][j].calc;
          let tag_id = this.unionForm.domains[i][j].tag_id;
          let limit_by = tag_id.substring(0, 1);
          tag_id = tag_id.substring(2, tag_id.length);
          let tag_time = tag_id + "_time";
          let value = this.unionForm.domains[i][j].value;
          let valueOptions = this.unionForm.domains[i][j].valueOptions;
          let valueOpLength = valueOptions.length;
          if (
            (limit_by == 1 && unionTimeRange1.length > 0) ||
            (limit_by == 2 && unionTimeRange2.length > 0) ||
            (limit_by == 3 && unionTimeRange3.length > 0)
          ) {
            let calc_arr = [];
            // 动态生成 标签-时间范围 过滤条件
            let tag_time_tmp = "";
            if (limit_by == 1) {
              tag_time_tmp =
                this.showTime(unionTimeRange1[0]._d) +
                "_" +
                this.showTime(unionTimeRange1[1]._d);
            } else if (limit_by == 2) {
              tag_time_tmp =
                this.showTime(unionTimeRange2[0]._d) +
                "_" +
                this.showTime(unionTimeRange2[1]._d);
            } else {
              tag_time_tmp =
                this.showTime(unionTimeRange3[0]._d) +
                "_" +
                this.showTime(unionTimeRange3[1]._d);
            }
            let op_tmp = "";
            if (operate == "等于") {
              op_tmp = "eq";
            } else if (operate == "不等于") {
              op_tmp = "noteq";
            } else if (operate == "大于") {
              op_tmp = "gt";
            } else if (operate == "大于等于") {
              op_tmp = "gte";
            } else if (operate == "小于") {
              op_tmp = "lt";
            } else if (operate == "小于等于") {
              op_tmp = "lte";
            } else if (operate == "包含") {
              op_tmp = "eq";
            } else if (operate == "不包含") {
              op_tmp = "noteq";
            }
            for (let v_inx = 0; v_inx < value.length; v_inx++) {
              let calc_obj = {};
              let tag = value[v_inx] + "_" + op_tmp + "_" + tag_time_tmp;
              if (valueOpLength < 1) {
                tag = tag_id + "_" + tag_time_tmp + "_" + op_tmp + "_" + value[v_inx];
              }
              this.calc_time_arr.push(tag);
              tag += ".keyword";
              let termObj = {};
              termObj[tag] = "";
              calc_obj.term = termObj;
              calc_arr.push(calc_obj);
            }
            if (union_parent_apposition == "且" && apposition == "且") {
              calc.bool.filter.bool.must.concat(calc_arr);
            }
            if (union_parent_apposition == "且" && apposition == "或") {
              if (j == 0) {
                let should_tmp = {
                  bool: {
                    should: [],
                  },
                };
                calc.bool.filter.bool.must.splice(0, 0, should_tmp);
              }
              calc.bool.filter.bool.must[0].bool.should.concat(calc_arr);
            }
            if (union_parent_apposition == "或" && apposition == "且") {
              if (j == 0) {
                let must_tmp = {
                  bool: {
                    must: [],
                  },
                };
                calc.bool.filter.bool.should.splice(0, 0, must_tmp);
              }
              calc.bool.filter.bool.should[0].bool.must.concat(calc_arr);
            }
            if (union_parent_apposition == "或" && apposition == "或") {
              calc.bool.filter.bool.should.concat(calc_arr);
            }
          } else if (
            limit_by == 0 ||
            (limit_by == 1 && unionTimeRange1.length < 1) ||
            (limit_by == 2 && unionTimeRange2.length < 1) ||
            (limit_by == 3 && unionTimeRange3.length < 1)
          ) {
            let calc_tmp = {};
            let terms_obj = {};
            if (valueOpLength > 0 && valueOptions[0].label != "time") {
              if (value instanceof Array) {
                let flag = value[0].lastIndexOf("_");
                let key = value[0].substring(0, flag);
                let val = [];
                if (operate.indexOf("包含") >= 0) {
                  val.push(value[0].substring(flag + 1, value[0].length));
                } else {
                  for (let inx = 0; inx < value.length; inx++) {
                    val.push(value[inx].substring(flag + 1, value[inx].length));
                  }
                }
                terms_obj[key] = val;
              } else {
                let flag = value.lastIndexOf("_");
                let key = value.substring(0, flag);
                let val = [];
                val.push(value.substring(flag + 1, value.length));
                terms_obj[key] = val;
              }
            } else if (operate == "等于") {
              terms_obj[tag_id] = value;
            }
            calc_tmp = {
              terms: terms_obj,
            };
            if (operate.indexOf("不") >= 0) {
              calc_tmp = {
                bool: {
                  must_not: [
                    {
                      terms: terms_obj,
                    },
                  ],
                },
              };
            }
            if (valueOpLength < 1 && operate == "大于") {
              terms_obj[tag_id] = {
                gt: value[0],
              };
              calc_tmp = {
                range: terms_obj,
              };
            }
            if (valueOpLength < 1 && operate == "大于等于") {
              terms_obj[tag_id] = {
                gte: value[0],
              };
              calc_tmp = {
                range: terms_obj,
              };
            }
            if (valueOpLength < 1 && operate == "小于") {
              terms_obj[tag_id] = {
                lt: value[0],
              };
              calc_tmp = {
                range: terms_obj,
              };
            }
            if (valueOpLength < 1 && operate == "小于等于") {
              terms_obj[tag_id] = {
                lte: value[0],
              };
              calc_tmp = {
                range: terms_obj,
              };
            }
            if (
              typeof valueOptions[0] != "undefined" &&
              valueOptions[0].label == "time"
            ) {
              terms_obj[tag_id] = [this.showTime(value[0]._d)];
              calc_tmp = {
                terms: terms_obj,
              };
              if (operate == "在区间") {
                terms_obj[tag_id] = {
                  gte: this.showTime(value[0]._d),
                  lte: this.showTime(value[1]._d),
                };
                calc_tmp = {
                  range: terms_obj,
                };
              }
            }
            if (union_parent_apposition == "且" && apposition == "且") {
              calc.bool.filter.bool.must.push(calc_tmp);
            }
            if (union_parent_apposition == "且" && apposition == "或") {
              if (j == 0) {
                let should_tmp = {
                  bool: {
                    should: [],
                  },
                };
                calc.bool.filter.bool.must.splice(0, 0, should_tmp);
              }
              calc.bool.filter.bool.must[0].bool.should.push(calc_tmp);
            }
            if (union_parent_apposition == "或" && apposition == "且") {
              if (j == 0) {
                let must_tmp = {
                  bool: {
                    must: [],
                  },
                };
                calc.bool.filter.bool.should.splice(0, 0, must_tmp);
              }
              calc.bool.filter.bool.should[0].bool.must.push(calc_tmp);
            }
            if (union_parent_apposition == "或" && apposition == "或") {
              calc.bool.filter.bool.should.push(calc_tmp);
            }
          }
        }
      }
      if (this.differentForm.domains.length > 0) {
        let different_parent_operate = this.differentForm.domains[0][0].apposition;
        calc.bool.filter.bool.must_not = [
          {
            bool: {},
          },
        ];
        if (different_parent_operate == "且") {
          calc.bool.filter.bool.must_not[0].bool.must = [];
        } else {
          calc.bool.filter.bool.must_not[0].bool.should = [];
        }
        for (let i = 0; i < this.differentForm.domains.length; i++) {
          for (let j = 0; j < this.differentForm.domains[i].length; j++) {
            let apposition =
              this.differentForm.domains[i].length > 1
                ? this.differentForm.domains[i][1].apposition
                : this.differentForm.domains[i][0].apposition;
            let operate = this.differentForm.domains[i][j].calc;
            let tag_id = this.differentForm.domains[i][j].tag_id;
            let limit_by = tag_id.substring(0, 1);
            tag_id = tag_id.substring(2, tag_id.length);
            let tag_time = tag_id + "_time";
            let value = this.differentForm.domains[i][j].value;
            let valueOptions = this.differentForm.domains[i][j].valueOptions;
            let valueOpLength = valueOptions.length;
            if (
              (limit_by == 1 && differentTimeRange1.length > 0) ||
              (limit_by == 2 && differentTimeRange2.length > 0) ||
              (limit_by == 3 && differentTimeRange3.length > 0)
            ) {
              let calc_arr = [];
              // 动态生成 标签-时间范围 过滤条件
              let tag_time_tmp = "";
              if (limit_by == 1) {
                tag_time_tmp =
                  this.showTime(differentTimeRange1[0]._d) +
                  "_" +
                  this.showTime(differentTimeRange1[1]._d);
              } else if (limit_by == 2) {
                tag_time_tmp =
                  this.showTime(differentTimeRange2[0]._d) +
                  "_" +
                  this.showTime(differentTimeRange2[1]._d);
              } else {
                tag_time_tmp =
                  this.showTime(differentTimeRange3[0]._d) +
                  "_" +
                  this.showTime(differentTimeRange3[1]._d);
              }
              let op_tmp = "";
              if (operate == "等于") {
                op_tmp = "eq";
              } else if (operate == "不等于") {
                op_tmp = "noteq";
              } else if (operate == "大于") {
                op_tmp = "gt";
              } else if (operate == "大于等于") {
                op_tmp = "gte";
              } else if (operate == "小于") {
                op_tmp = "lt";
              } else if (operate == "小于等于") {
                op_tmp = "lte";
              } else if (operate == "包含") {
                op_tmp = "eq";
              } else if (operate == "不包含") {
                op_tmp = "noteq";
              }
              for (let v_inx = 0; v_inx < value.length; v_inx++) {
                let calc_obj = {};
                let tag = value[v_inx] + "_" + op_tmp + "_" + tag_time_tmp;
                if (valueOpLength < 1) {
                  tag = tag_id + "_" + tag_time_tmp + "_" + op_tmp + "_" + value[v_inx];
                }
                this.calc_time_arr.push(tag);
                tag += ".keyword";
                let termObj = {};
                termObj[tag] = "";
                calc_obj.term = termObj;
                calc_arr.push(calc_obj);
              }
              if (different_parent_operate == "且" && apposition == "且") {
                calc.bool.filter.bool.must_not[0].bool.must.concat(calc_arr);
              }
              if (different_parent_operate == "且" && apposition == "或") {
                if (j == 0) {
                  let should_tmp = {
                    bool: {
                      should: [],
                    },
                  };
                  calc.bool.filter.bool.must_not[0].bool.must.splice(0, 0, should_tmp);
                }
                calc.bool.filter.bool.must_not[0].bool.must[0].bool.should.concat(
                  calc_arr
                );
              }
              if (different_parent_operate == "或" && apposition == "且") {
                if (j == 0) {
                  let must_tmp = {
                    bool: {
                      must: [],
                    },
                  };
                  calc.bool.filter.bool.must_not[0].bool.should.splice(0, 0, must_tmp);
                }
                calc.bool.filter.bool.must_not[0].bool.should[0].bool.must.concat(
                  calc_arr
                );
              }
              if (different_parent_operate == "或" && apposition == "或") {
                calc.bool.filter.bool.must_not[0].bool.should.concat(calc_arr);
              }
            } else if (
              limit_by == 0 ||
              (limit_by == 1 && unionTimeRange1.length < 1) ||
              (limit_by == 2 && unionTimeRange2.length < 1) ||
              (limit_by == 3 && unionTimeRange3.length < 1)
            ) {
              let calc_tmp = {};
              let terms_obj = {};
              if (valueOpLength > 0 && valueOptions[0].label != "time") {
                if (value instanceof Array) {
                  let flag = value[0].lastIndexOf("_");
                  let key = value[0].substring(0, flag);
                  let val = [];
                  if (operate.indexOf("包含") >= 0) {
                    val.push(value[0].substring(flag + 1, value[0].length));
                  } else {
                    for (let inx = 0; inx < value.length; inx++) {
                      val.push(value[inx].substring(flag + 1, value[inx].length));
                    }
                  }
                  terms_obj[key] = val;
                } else {
                  let flag = value.lastIndexOf("_");
                  let key = value.substring(0, flag);
                  let val = [];
                  val.push(value.substring(flag + 1, value.length));
                  terms_obj[key] = val;
                }
              } else if (operate == "等于") {
                terms_obj[tag_id] = value;
              }
              calc_tmp = {
                terms: terms_obj,
              };
              if (operate.indexOf("不") >= 0) {
                calc_tmp = {
                  bool: {
                    must_not: [
                      {
                        terms: terms_obj,
                      },
                    ],
                  },
                };
              }
              if (valueOpLength < 1 && operate == "大于") {
                terms_obj[tag_id] = {
                  gt: value[0],
                };
                calc_tmp = {
                  range: terms_obj,
                };
              }
              if (valueOpLength < 1 && operate == "大于等于") {
                terms_obj[tag_id] = {
                  gte: value[0],
                };
                calc_tmp = {
                  range: terms_obj,
                };
              }
              if (valueOpLength < 1 && operate == "小于") {
                terms_obj[tag_id] = {
                  lt: value[0],
                };
                calc_tmp = {
                  range: terms_obj,
                };
              }
              if (valueOpLength < 1 && operate == "小于等于") {
                terms_obj[tag_id] = {
                  lte: value[0],
                };
                calc_tmp = {
                  range: terms_obj,
                };
              }
              if (
                typeof valueOptions[0] != "undefined" &&
                valueOptions[0].label == "time"
              ) {
                terms_obj[tag_id] = [this.showTime(value[0]._d)];
                calc_tmp = {
                  terms: terms_obj,
                };
                if (operate == "在区间") {
                  terms_obj[tag_id] = {
                    gte: this.showTime(value[0]._d),
                    lte: this.showTime(value[1]._d),
                  };
                  calc_tmp = {
                    range: terms_obj,
                  };
                }
              }
              if (different_parent_operate == "且" && apposition == "且") {
                calc.bool.filter.bool.must_not[0].bool.must.push(calc_tmp);
              }
              if (different_parent_operate == "且" && apposition == "或") {
                if (j == 0) {
                  let should_tmp = {
                    bool: {
                      should: [],
                    },
                  };
                  calc.bool.filter.bool.must_not[0].bool.must.splice(0, 0, should_tmp);
                }
                calc.bool.filter.bool.must_not[0].bool.must[0].bool.should.push(calc_tmp);
              }
              if (different_parent_operate == "或" && apposition == "且") {
                if (j == 0) {
                  let must_tmp = {
                    bool: {
                      must: [],
                    },
                  };
                  calc.bool.filter.bool.must_not[0].bool.should.splice(0, 0, must_tmp);
                }
                calc.bool.filter.bool.must_not[0].bool.should[0].bool.must.push(calc_tmp);
              }
              if (different_parent_operate == "或" && apposition == "或") {
                calc.bool.filter.bool.must_not[0].bool.should.push(calc_tmp);
              }
            }
          }
        }
      }
      return calc;
    },
    // 查询人群人数
    loadPopulation() {
      let unionFormValid = true;
      if (this.unionForm.domains.length > 0) {
        unionFormValid = false;
        this.$refs.unionForm.validate((valid) => {
          if (valid) {
            unionFormValid = true;
          }
        });
      }
      let differentFormValid = true;
      if (this.differentForm.domains.length > 0) {
        differentFormValid = false;
        this.$refs.differentForm.validate((valid) => {
          if (valid) {
            differentFormValid = true;
          }
        });
      }
      if (!unionFormValid || !differentFormValid) {
        return;
      }

      let calc = this.getCalc();

      this.reload = true;

      if (this.showShrink && this.showShrinkNum) {
        this.popNum = this.shrinkNum;
        setTimeout(() => {
          this.reload = false;
        }, 1200);
        return;
      }

      let body = {
        calc: JSON.stringify(calc),
        time_tag: JSON.stringify(this.calc_time_arr),
      };
      addUserGroupService
        .loadPopulationSize(this, { data: body })
        .then(
          function (response) {
            let res = response.data;
            if (res.code == "200") {
              this.popNum = res.data;
              loadPopNum = res.data;
              this.shrinkForm.shrink_user_num = res.data;
              setTimeout(() => {
                this.reload = false;
              }, 1200);
            }
          }.bind(this)
        )
        .catch((response) => {
          console.log(response);
        });
    },
    // 保存Modal
    openSaveModal() {
      this.loadPopulation();
      this.saveForm = {
        group_name: "",
        group_type: "",
      };
      setTimeout(() => {
        this.$refs.saveForm.resetFields();
      }, 20);
      this.saveModal = true;
    },
    saveBtn() {
      this.$refs.saveForm.validate((valid) => {
        if (valid) {
          if (this.saveForm.group_type == "静态" && this.popNum > 1000000) {
            this.$message.info("为保证系统资源，大于100万的人群不允许保存为静态人群！");
            return;
          }
          this.reload = true;
          this.saveModal = false;
          let user_count = this.popNum;
          let tmp = {
            unionForm: this.unionForm,
            differentForm: this.differentForm,
          };
          if (this.showShrink) {
            tmp.random_count = this.shrinkNum;
            user_count = this.shrinkNum;
          }
          let tag_cnd = this.$route.params.tag_cnd;
          let body = {
            group_name: this.saveForm.group_name,
            user_count: user_count,
            calc_type: this.saveForm.group_type,
            cnd: JSON.stringify(this.getCalc()),
            tag_cnd: JSON.stringify(tmp),
            op_type:
              typeof tag_cnd != "undefined" ? "复制" : this.showShrink ? "随机" : "新建",
          };
          addUserGroupService
            .addUserGroup(this, { data: body })
            .then(
              function (response) {
                let res = response.data;
                if (res.code == "200") {
                  this.$message.info(res.message);
                  setTimeout(() => {
                    const newPath = this.$router.resolve({
                      path: "/dataAnalysis/userAnalysis",
                      query: {
                        group_id: res.data,
                        oms_time_range: this.unionForm.timeRange1,
                        crm_time_range: this.unionForm.timeRange2,
                        sensor_time_range: this.unionForm.timeRange3,
                      },
                    });
                    this.$router.push({
                      path: "/dataAnalysis/userGroupList",
                    });
                    window.open(newPath.href, "_blank");
                  }, 600);
                } else {
                  this.$message.info(res.message);
                }
              }.bind(this)
            )
            .catch((response) => {
              console.log(response);
            });
        }
      });
    },
    closeSaveModal() {
      this.$refs.saveForm.resetFields();
      this.saveModal = false;
    },
    // 时间格式化
    showTime(value) {
      return utils.formatDate(value, "yyyy-MM-dd");
    },
    // 数字的千位分隔符
    showThousandNum(value) {
      return utils.showThousandNumber(value);
    },
    // 格式化复制人群时的数据
    getDomains(form) {
      let union_length = form.domains.length;
      if (typeof form.timeRange1[0] != "undefined" && form.timeRange1[0].length > 10) {
        let range1_start = moment(new Date(form.timeRange1[0].substring(0, 10)));
        let range1_end = moment(new Date(form.timeRange1[1].substring(0, 10)));
        form.timeRange1 = [range1_start, range1_end];
      }
      if (typeof form.timeRange2[0] != "undefined" && form.timeRange2[0].length > 10) {
        let range2_start = moment(new Date(form.timeRange2[0].substring(0, 10)));
        let range2_end = moment(new Date(form.timeRange2[1].substring(0, 10)));
        form.timeRange2 = [range2_start, range2_end];
      }
      if (typeof form.timeRange3[0] != "undefined" && form.timeRange3[0].length > 10) {
        let range3_start = moment(new Date(form.timeRange3[0].substring(0, 10)));
        let range3_end = moment(new Date(form.timeRange3[1].substring(0, 10)));
        form.timeRange3 = [range3_start, range3_end];
      }
      for (let i = 0; i < union_length; i++) {
        let union_child_length = form.domains[i].length;
        for (let ch_inx = 0; ch_inx < union_child_length; ch_inx++) {
          let child_valueOptions = form.domains[i][ch_inx].valueOptions;
          let child_value = form.domains[i][ch_inx].value;
          if (
            typeof child_valueOptions[0] != "undefined" &&
            child_valueOptions[0].label == "time"
          ) {
            form.domains[i][ch_inx].value = [
              moment(new Date(child_value[0].substring(0, 10))),
              moment(new Date(child_value[1].substring(0, 10))),
            ];
          }
        }
      }
      return form;
    },
    // 筛选模块oms时间框禁用范围
    unionOmsDisabledDate(date) {
      let start = utils.formatDate(date._d, "yyyyMMdd");
      let end = utils.formatDate(new Date(), "yyyyMMdd");
      if (start < 20180101) {
        return true;
      }
      if (start > end) {
        return true;
      }
      if (this.unionForm.timeRange1.length > 0 && !this.admin) {
        let tmp = utils.formatDate(this.unionForm.timeRange1[0]._d, "yyyy-MM-dd");
        let start_pre = moment(new Date(tmp)).subtract(90, "days");
        let end_suf = moment(new Date(tmp)).add(90, "days");
        let prefix = utils.formatDate(start_pre._d, "yyyyMMdd");
        let suffix = utils.formatDate(end_suf._d, "yyyyMMdd");
        prefix = prefix < 20180101 ? 20180101 : prefix;
        suffix = suffix > end ? end : suffix;
        if (start < prefix) {
          return true;
        }
        if (start > suffix) {
          return true;
        }
      }
      return false;
    },
    unionOmsDisabledRange(dates) {
      if (dates.length == 1) {
        this.unionForm.timeRange1[0] = dates[0];
      }
    },
    // 筛选模块crm时间框禁用范围
    unionCrmDisabledDate(date) {
      let start = utils.formatDate(date._d, "yyyyMMdd");
      let end = utils.formatDate(new Date(), "yyyyMMdd");
      if (start < 20180101) {
        return true;
      }
      if (start > end) {
        return true;
      }
      if (this.unionForm.timeRange2.length > 0 && !this.admin) {
        let tmp = utils.formatDate(this.unionForm.timeRange2[0]._d, "yyyy-MM-dd");
        let start_pre = moment(new Date(tmp)).subtract(90, "days");
        let end_suf = moment(new Date(tmp)).add(90, "days");
        let prefix = utils.formatDate(start_pre._d, "yyyyMMdd");
        let suffix = utils.formatDate(end_suf._d, "yyyyMMdd");
        prefix = prefix < 20180101 ? 20180101 : prefix;
        suffix = suffix > end ? end : suffix;
        if (start < prefix) {
          return true;
        }
        if (start > suffix) {
          return true;
        }
      }
      return false;
    },
    unionCrmDisabledRange(dates) {
      if (dates.length == 1) {
        this.unionForm.timeRange2[0] = dates[0];
      }
    },
    // 筛选模块sensor时间框禁用范围
    unionSensorDisabledDate(date) {
      let start = utils.formatDate(date._d, "yyyyMMdd");
      let pre_start = moment(new Date()).subtract(180, "days");
      let pre_start_tmp = utils.formatDate(pre_start._d, "yyyyMMdd");
      if (this.admin) {
        pre_start_tmp = 20200301;
      }
      let end = utils.formatDate(new Date(), "yyyyMMdd");
      if (start < pre_start_tmp) {
        return true;
      }
      if (start > end) {
        return true;
      }
      if (this.unionForm.timeRange3.length > 0 && !this.admin) {
        let tmp = utils.formatDate(this.unionForm.timeRange3[0]._d, "yyyy-MM-dd");
        let start_pre = moment(new Date(tmp)).subtract(90, "days");
        let end_suf = moment(new Date(tmp)).add(90, "days");
        let prefix = utils.formatDate(start_pre._d, "yyyyMMdd");
        let suffix = utils.formatDate(end_suf._d, "yyyyMMdd");
        prefix = prefix < pre_start_tmp ? pre_start_tmp : prefix;
        suffix = suffix > end ? end : suffix;
        if (start < prefix) {
          return true;
        }
        if (start > suffix) {
          return true;
        }
      }
      return false;
    },
    unionSensorDisabledRange(dates) {
      if (dates.length == 1) {
        this.unionForm.timeRange3[0] = dates[0];
      }
    },
    // 排除模块oms时间框禁用范围
    differentOmsDisabledDate(date) {
      let start = utils.formatDate(date._d, "yyyyMMdd");
      let end = utils.formatDate(new Date(), "yyyyMMdd");
      if (start < 20180101) {
        return true;
      }
      if (start > end) {
        return true;
      }
      if (this.differentForm.timeRange1.length > 0 && !this.admin) {
        let tmp = utils.formatDate(this.differentForm.timeRange1[0]._d, "yyyy-MM-dd");
        let start_pre = moment(new Date(tmp)).subtract(90, "days");
        let end_suf = moment(new Date(tmp)).add(90, "days");
        let prefix = utils.formatDate(start_pre._d, "yyyyMMdd");
        let suffix = utils.formatDate(end_suf._d, "yyyyMMdd");
        prefix = prefix < 20180101 ? 20180101 : prefix;
        suffix = suffix > end ? end : suffix;
        if (start < prefix) {
          return true;
        }
        if (start > suffix) {
          return true;
        }
      }
      return false;
    },
    differentOmsDisabledRange(dates) {
      if (dates.length == 1) {
        this.differentForm.timeRange1[0] = dates[0];
      }
    },
    // 排除模块crm时间框禁用范围
    differentCrmDisabledDate(date) {
      let start = utils.formatDate(date._d, "yyyyMMdd");
      let end = utils.formatDate(new Date(), "yyyyMMdd");
      if (start < 20180101) {
        return true;
      }
      if (start > end) {
        return true;
      }
      if (this.differentForm.timeRange2.length > 0 && !this.admin) {
        let tmp = utils.formatDate(this.differentForm.timeRange2[0]._d, "yyyy-MM-dd");
        let start_pre = moment(new Date(tmp)).subtract(90, "days");
        let end_suf = moment(new Date(tmp)).add(90, "days");
        let prefix = utils.formatDate(start_pre._d, "yyyyMMdd");
        let suffix = utils.formatDate(end_suf._d, "yyyyMMdd");
        prefix = prefix < 20180101 ? 20180101 : prefix;
        suffix = suffix > end ? end : suffix;
        if (start < prefix) {
          return true;
        }
        if (start > suffix) {
          return true;
        }
      }
      return false;
    },
    differentCrmDisabledRange(dates) {
      if (dates.length == 1) {
        this.differentForm.timeRange2[0] = dates[0];
      }
    },
    // 排除模块sensor时间框禁用范围
    differentSensorDisabledDate(date) {
      let start = utils.formatDate(date._d, "yyyyMMdd");
      let pre_start = moment(new Date()).subtract(180, "days");
      let pre_start_tmp = utils.formatDate(pre_start._d, "yyyyMMdd");
      if (this.admin) {
        pre_start_tmp = 20200301;
      }
      let end = utils.formatDate(new Date(), "yyyyMMdd");
      if (start < pre_start_tmp) {
        return true;
      }
      if (start > end) {
        return true;
      }
      if (this.differentForm.timeRange3.length > 0 && !this.admin) {
        let tmp = utils.formatDate(this.differentForm.timeRange3[0]._d, "yyyy-MM-dd");
        let start_pre = moment(new Date(tmp)).subtract(90, "days");
        let end_suf = moment(new Date(tmp)).add(90, "days");
        let prefix = utils.formatDate(start_pre._d, "yyyyMMdd");
        let suffix = utils.formatDate(end_suf._d, "yyyyMMdd");
        prefix = prefix < pre_start_tmp ? pre_start_tmp : prefix;
        suffix = suffix > end ? end : suffix;
        if (start < prefix) {
          return true;
        }
        if (start > suffix) {
          return true;
        }
      }
      return false;
    },
    differentSensorDisabledRange(dates) {
      if (dates.length == 1) {
        this.differentForm.timeRange3[0] = dates[0];
      }
    },
  },
};
</script>

<style scoped>
.button-div {
  margin-top: 30px;
  float: right;
}
.button-div button,
.inner-add-filter button {
  margin-left: 20px;
}
.check-box-div {
  line-height: 32px;
  margin-top: 30px;
  float: left;
}
.filter-card {
  margin-top: 30px;
}
.inner-add-filter {
  float: right;
}
.close-total-filter {
  float: right;
  margin: -20px -15px;
}
.filter-card-different {
  margin-top: 30px;
  background: #f5f5f5;
}
.different-title {
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
  margin-bottom: 30px;
}
</style>
